import React, { useState, useEffect, useRef } from "react";
import { useLanguage } from "../../Translations/LenguageContext";
import stripeNation from "../../JSON/SupportedStripeCountries.json";
import PopupMex from "../../Components/SavePopup";
import Spinner from "../../Components/Spinner";
import { RiTranslate2 } from "react-icons/ri";
import FormatDateTime from "../../Functions/FormatDate";


function Profile({ userData }) {
    const { t, changeLanguage, language } = useLanguage();
    const userId = sessionStorage.getItem("user_id");
    const [isModified, setIsModified] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [popupActive, setPopupActive] = useState(false);
    const [popupType, setPopupType] = useState("success");
    const [iconClass, setIconClass] = useState('fa-solid fa-copy');
    const [err, setErr] = useState({ message: "", display: false });
    const [loading, setLoading] = useState(false);
    const userIdRef = useRef(null);

    const [fieldErrors, setFieldErrors] = useState({
        email: "",
        password: "",
        name: "",
        surname: ""
    });
    const [formData, setFormData] = useState({
        name: '',
        surname: '',
        email: '',
        password: '',
        updated_at: '',
    });

    const handleLanguageChange = (event) => {
        changeLanguage(event.target.value);
    };

    useEffect(() => {
        if (userData) {
            setFormData({
                name: userData.personal_info.name || '',
                surname: userData.personal_info.surname || '',
                email: userData.personal_info.email || '',
                password: userData.personal_info.password || '',
                updated_at: userData.updated_at || ''
            });
        }
    }, [userData]);


    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
        setIsModified(true);
    };

    const handleUpdate = () => {
        setLoading(true)
        fetch("https://backend.erioon.com/modify_user", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                userId: userId,
                ...formData
            })
        })
            .then(response => response.json())
            .then(data => {
                setLoading(false)
                setErr({ message: "", display: false });
                if (data.message === "OK") {
                    setIsModified(false);
                    setPopupType("success");
                    setPopupActive(true);
                } else {
                    alert('Error updating profile: ' + data.error);
                }
            })
            .catch(error => {
                setLoading(false);
                setErr({ message: t.register_form.problem_back, display: true });
            });
    };


    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&-])[A-Za-z\d@$!%*?&-]{10,20}$/;

    const validateEmail = (email) => {
        return emailRegex.test(email);
    };

    const validatePassword = (password) => {
        return passwordRegex.test(password);
    };

    const setFieldError = (field, hasError) => {
        field.style.borderBottom = hasError ? "2px solid var(--danger)" : "";
        return hasError;
    };

    const CheckFields = () => {
        const errors = {
            email: "",
            password: "",
            name: "",
            surname: ""
        };
        let hasError = false;

        if (!formData.email) {
            errors.email = t.register_form.red_fields;
            hasError = true;
        } else if (!validateEmail(formData.email)) {
            errors.email = t.register_form.email_format;
            hasError = true;
        }

        if (formData.password && !validatePassword(formData.password)) {
            errors.password = t.register_form.password_err;
            hasError = true;
        }

        if (!formData.name) {
            errors.name = t.register_form.red_fields;
            hasError = true;
        }

        if (!formData.surname) {
            errors.surname = t.register_form.red_fields;
            hasError = true;
        }

        setFieldErrors(errors);

        if (!hasError) {
            handleUpdate();
        }
    };


    const handlePopupClose = () => {
        setPopupActive(false);
    };

    const copyToClipboard = async () => {
        try {
            await navigator.clipboard.writeText(userId);
            setIconClass('fa-solid fa-check');
            setTimeout(() => {
                setIconClass('fa-solid fa-copy');
            }, 3000);
        } catch (err) {
            console.error('Failed to copy: ', err);
        }
    };

    return (
        <div className="middle_cont_main">
            <p className="main_view_title fade-in">Profile</p>
            <p className="main_view_subtitle fade-in">Your personal details</p>
            <div className="profile_container fade-in">
                <div className="section_profile">
                    <p className="section_profile_title">{t.profile.uid_title}</p>
                    <p className="under_title_profile">{t.profile.uid_subtitle}</p>

                    <div className="user_id_cont">
                        <p className="user_id">{userId}</p>
                        <button className="copy_user_id_btn" onClick={copyToClipboard}>
                            <i className={iconClass}></i>
                        </button>
                    </div>
                </div>
                <div className="section_profile">
                    <p className="section_profile_title">{t.profile.access}</p>
                    <p className="under_title_profile">{t.profile.main_credentials_subtitle}</p>
                    <div className="section_profile_double_face">
                        <div className="section_input_cont">
                            <div className="label_input_cont_profile">
                                <label className="label_profile">{t.register_form.name}</label>
                                <input
                                    id="name"
                                    type="text"
                                    className={`input_profile ${fieldErrors.name ? "input_error" : ""}`}
                                    value={formData.name}
                                    name="name"
                                    onChange={handleInputChange}
                                />
                            </div>
                            {fieldErrors.name && <p className="input_error_message">{fieldErrors.name}</p>}

                            <div className="label_input_cont_profile">
                                <label className="label_profile">{t.register_form.surname}</label>
                                <input
                                    id="surname"
                                    type="text"
                                    className={`input_profile ${fieldErrors.surname ? "input_error" : ""}`}
                                    value={formData.surname}
                                    name="surname"
                                    onChange={handleInputChange}
                                />
                            </div>
                            {fieldErrors.surname && <p className="input_error_message">{fieldErrors.surname}</p>}

                            <div className="label_input_cont_profile">
                                <label className="label_profile">Email</label>
                                <input
                                    id="email"
                                    type="email"
                                    className={`input_profile ${fieldErrors.email ? "input_error" : ""}`}
                                    value={formData.email}
                                    name="email"
                                    onChange={handleInputChange}
                                />
                            </div>
                            {fieldErrors.email && <p className="input_error_message">{fieldErrors.email}</p>}

                            <div className="label_input_cont_profile">
                                <label className="label_profile">Password</label>
                                <input
                                    autoComplete="new-password"
                                    id="password"
                                    type={showPassword ? "text" : "password"}
                                    className={`input_profile input_profile_password ${fieldErrors.password ? "input_error" : ""}`}
                                    placeholder="**********************"
                                    name="password"
                                    onChange={handleInputChange}
                                />
                                <button className="show_passowrd_profile" onClick={togglePasswordVisibility}>
                                    <i className={`fa-regular fa-eye${showPassword ? "" : "-slash"}`}></i>
                                </button>
                            </div>
                            {fieldErrors.password && <p className="input_error_message">{fieldErrors.password}</p>}

                        </div>
                    </div>

                    {isModified && (
                        <div className="btn_cont_profile">
                            <button className="save_profile_updates_btn" onClick={CheckFields}>
                                {loading ? (
                                    <Spinner loading={loading} err={err}></Spinner>
                                ) : (
                                    <>
                                        <i className="fa-solid fa-save"></i> {t.profile.update_btn} information
                                    </>
                                )}

                            </button>
                        </div>
                    )}
                </div>

                <div className="section_profile">
                    <p className="section_profile_title">System language</p>
                    <p className="under_title_profile">The current sys language is setted to {language}</p>
                    <div className="link_container link_cont_footer_sidebar">
                        <div className="profile_cont_link">
                            <i><RiTranslate2 /></i>
                            <select className="language_select_sidebar" onChange={handleLanguageChange} value={language}>
                                <option value="en">English</option>
                                {/* <option value="it">Italiano</option> */}
                            </select>
                        </div>
                    </div>
                </div>

                {/* <div className="section_profile">
                    <p className="section_profile_title">{t.profile.activity_log}</p>
                    <p className="under_title_profile">{t.profile.activity_log_subtitle}</p>

                    <div className="activity_log_container">
                        {Array.isArray(formData.updated_at) && formData.updated_at.length > 0 ? (
                            formData.updated_at.map((entry, index) => (

                                entry.update_type === "01-ACT" ? (
                                    <div

                                        key={index}
                                        className={`activity_log_entry ${entry.status_update === 'OK' ? 'success_activity' :
                                            entry.status_update === 'KO' ? 'error_activity' : ''
                                            }`}
                                    >
                                        <span className="activity_check">
                                            <i className={`fa-solid ${entry.status_update === 'OK' ? 'fa-check' : 'fa-x'}`}></i>
                                        </span>
                                        <p className="activity_log_cell update_type">{entry.message}</p>
                                        <p className="activity_log_cell timestamp">{entry.status_update}</p>
                                        <p className="activity_log_cell timestamp">{FormatDateTime(entry.timestamp)}</p>
                                    </div>
                                ) : (
                                    <p className='no_data_mex'>{t.profile.no_activity}</p>
                                )

                            ))
                        ) : (
                            <div className='no_data_mex_cont'>
                                <p className='no_data_mex'>{t.profile.no_activity}</p>
                            </div>
                        )}
                    </div>



                </div> */}
            </div >
            <PopupMex active={popupActive} type={popupType} message={""} onClose={handlePopupClose} />
        </div >
    );
}

export default Profile;
